import React from "react";
import Box from "@mui/material/Box";
import Item from "./Item";
import Typography from "@mui/material/Typography";

// Base URL for Vercel Blob storage
const BLOB_BASE_URL = "https://eezvqt4vd5kslelz.public.blob.vercel-storage.com";

// Helper function to get image URL
const getImageUrl = (imageName) => {
  return `${BLOB_BASE_URL}/${imageName}`;
};

// Default fallback items using dynamic image URLs
const defaultFallbackItems = [
  {
    id: 1,
    Name: "Blue Sneakers",
    price: 79.99,
    category: "Shoes",
    image: { url: getImageUrl("IMG_7861.PNG") },
  },
  {
    id: 2,
    Name: "White Sneakers",
    price: 89.99,
    category: "Shoes",
    image: { url: getImageUrl("IMG_7846.PNG") },
  },
  {
    id: 3,
    Name: "White T-Shirt",
    price: 24.99,
    category: "T-Shirts",
    image: { url: getImageUrl("IMG_7845.PNG") },
  },
  {
    id: 4,
    Name: "Black Joggers",
    price: 49.99,
    category: "Pants",
    image: { url: getImageUrl("IMG_7868.PNG") },
  },
  {
    id: 5,
    Name: "Black T-Shirt",
    price: 24.99,
    category: "T-Shirts",
    image: { url: getImageUrl("IMG_7844.PNG") },
  },
  {
    id: 6,
    Name: "Black Jeans",
    price: 59.99,
    category: "Pants",
    image: { url: getImageUrl("IMG_7829.PNG") },
  },
  {
    id: 7,
    Name: "Pink T-Shirt",
    price: 29.99,
    category: "T-Shirts",
    image: { url: getImageUrl("IMG_7816.PNG") },
  },
  {
    id: 8,
    Name: "Red T-Shirt",
    price: 29.99,
    category: "T-Shirts",
    image: { url: getImageUrl("IMG_7808.PNG") },
  },
  {
    id: 9,
    Name: "Blue Jeans",
    price: 59.99,
    category: "Pants",
    image: { url: getImageUrl("Screenshot%202025-07-06%20at%2014.16.36.png") },
  },
];

const FallbackItems = ({ items = defaultFallbackItems }) => (
  <Box width="80%" margin="80px auto">
    <Typography variant="h4" textAlign="center" mb={3}>
      Fallback <b>Products</b>
    </Typography>
    <Box
      margin="0 auto"
      display="grid"
      gridTemplateColumns="repeat(auto-fill, 300px)"
      justifyContent="center"
      rowGap="20px"
      columnGap="1.33%"
      sx={{
        "@media (max-width:600px)": {
          justifyContent: "center",
        },
      }}
    >
      {items.map((item) => (
        <Item item={item} key={`${item.Name}-${item.id}`} />
      ))}
    </Box>
  </Box>
);

export default FallbackItems;
